import { Stack } from "@certn/cascadia";
import { Card } from "@certn/cascadia-react";
import { Skeleton } from "@certn/cascadia-react/patterns/skeleton/Skeleton";

import { css } from "@emotion/css";

export function LoadingSkeleton() {
  return (
    <Card className={styles.skeleton}>
      <Stack orientation="horizontal" justify="space-between">
        <Skeleton width={100} />
        <Skeleton width={20} />
      </Stack>
      <Skeleton width={200} />
      <Stack orientation="vertical">
        <Skeleton width={100} />
        <Skeleton width={150} />
      </Stack>
      <Skeleton width={60} />
    </Card>
  );
}
const styles = {
  skeleton: css({
    padding: "var(--space-4)",
  }),
};
